/* eslint-disable import/order */
import React from "react";

import { Routes, Route, useNavigate } from "react-router-dom";

import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";

import SOMPO_THEME from "./component/Theme";

import Home from "./pages/home/Home";
import Information from "./pages/information/Information";
import InformationDetail from "./pages/information/InformationDetail";
import Profile from "./pages/profile/Profile";
import TrainingList from "./pages/training/TrainingList";
import TrainingDetail from "./pages/training/detail/TrainingDetail";
import ApplicationTraining from "./pages/training/Application";
import CancelTraining from "./pages/training/Cancel";
import CurriculumDetail from "./pages/curriculum/CurriculumDetail";
import ApplicationCurriculum from "./pages/curriculum/Application";
import CancelCurriculum from "./pages/curriculum/Cancel";
import Skill from "./pages/skill/Skill";
import ChangePassword from "./pages/changePassword/ChangePassword";
import TestHistory from "./pages/training/detail/history/TestHistory";
import { TokenErrorDialog } from "./component/message/TokenErrorDialog";
import { ErrorDialog } from "./component/message/ErrorDialog";
import { InformationDialog } from "./component/message/InformationDialog";
import { ConfirmationDialog } from "./component/message/ConfirmationDialog";
import DefaultLogin from "./pages/login/DefaultLogin";
import DirectLogin from "./pages/login/DirectLogin";
import CancelAttendCareer from "./pages/training/CancelAttend";
import CancelAttendCurriculum from "./pages/curriculum/CancelAttend";

import SompoContext, { useSompoContext } from "./logic/context/SompoContext";
import { setNavigateFunction } from "./logic/hook/useRouterNavigation";

const App = () => {
    const sompoContext = useSompoContext();

    setNavigateFunction(useNavigate());

    return (
        <SompoContext.Provider value={sompoContext}>
            <ThemeProvider theme={SOMPO_THEME}>
                <CssBaseline />
                <InformationDialog />
                <ConfirmationDialog />
                <TokenErrorDialog />
                <ErrorDialog />
                <Routes>
                    <Route path="/" element={<DefaultLogin />} />
                    <Route path="/direct" element={<DirectLogin />} />
                    <Route path="/changePassword" element={<ChangePassword />} />

                    <Route path="/home" element={<Home />} />

                    <Route path="/information" element={<Information />} />
                    <Route path="/information/:type/:messageId" element={<InformationDetail />} />

                    <Route path="/profile" element={<Profile />} />

                    <Route path="/trainingList" element={<TrainingList />} />
                    <Route path="/training/detail/:careerId" element={<TrainingDetail />} />
                    <Route path="/training/detail/testHistory/:careerId/:classId" element={<TestHistory />} />

                    <Route path="/application/:careerId/:classId" element={<ApplicationTraining />} />
                    <Route path="/cancel/:careerId/:classId" element={<CancelTraining />} />
                    <Route path="/cancelAttend/:careerId/:classId" element={<CancelAttendCareer />} />

                    {/* カリキュラム関連 */}
                    <Route path="/curriculum/detail/:careerId" element={<CurriculumDetail />} />
                    <Route path="/curriculum/application/:careerId" element={<ApplicationCurriculum />} />
                    <Route path="/curriculum/cancel/:careerId" element={<CancelCurriculum />} />
                    <Route path="/curriculum/cancelAttend/:careerId" element={<CancelAttendCurriculum />} />

                    <Route path="/skill" element={<Skill />} />
                </Routes>
            </ThemeProvider>
        </SompoContext.Provider>
    );
};

export default App;
